import { Link } from 'foundations-components/transitional/components/Link';
import Raven from 'raven-js';
import { useEffect } from 'react';
import { useIsMobileLogin } from 'LoginUI/context/MobileLoginContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const ComplianceLink = () => {
  const isMobileLogin = useIsMobileLogin();
  useEffect(() => {
    try {
      // @ts-expect-error _hsg is provided by compliance script in index.html.tsx
      if (window._hsg) {
        // remount footer link on re-render
        const hiddenFooterCookieSettings = document.querySelector('.hs-footer-cookie-settings[hidden]');
        // @ts-expect-error _hsg is provided by compliance script in index.html.tsx
        if (hiddenFooterCookieSettings && window._hsg.compliance) {
          // @ts-expect-error _hsg is provided by compliance script in index.html.tsx
          window._hsg.compliance.addSettingsLink();
        }
      }
    } catch (error) {
      console.error(error);
      Raven.captureException(error);
    }
  }, []);
  return isMobileLogin ? null : /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx("span", {
      className: "hs-footer-cookie-settings",
      hidden: true,
      children: /*#__PURE__*/_jsx(Link, {
        href: "javascript:void(0)"
      })
    })
  });
};